/**
 * Eyebrow — the design's signature small all-caps label above every
 * section heading + every form field. Mono font, tracked, optional
 * `tone` for coral (section eyebrow) vs ink-3 (neutral / form-label).
 */
import { CSSProperties, ReactNode } from 'react';

type Props = {
  tone?: 'coral' | 'ink-3' | 'ink-2';
  size?: 'sm' | 'md';   // sm = 10.5px / md = 11px
  letter?: number;       // letter-spacing override
  style?: CSSProperties;
  children: ReactNode;
};

export function Eyebrow({ tone = 'ink-3', size = 'md', letter, style, children }: Props) {
  const color = tone === 'coral' ? 'var(--coral)' : tone === 'ink-2' ? 'var(--ink-2)' : 'var(--ink-3)';
  return (
    <div
      className="mono"
      style={{
        fontSize: size === 'sm' ? 10.5 : 11,
        color,
        letterSpacing: letter ?? (tone === 'coral' ? 2 : 1),
        textTransform: 'uppercase',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
